import { createAction, props } from '@ngrx/store';
import { IotAsset } from '../../models/iotAssetsModel.data';
import { AssetMappingConfig } from '../../models/asset-config.model';




// Azioni per il caricamento degli IoT Assets
export const loadIotAssets = createAction(
  '[IotAssets] Load IotAssets',
  props<{ assetType: string; uidCustomer: string; uidAssets: string[] }>()
);
export const loadIotAssetsSuccess = createAction('[IotAssets] Load IotAssets Success', props<{ iotAssets: IotAsset[] }>());
export const loadIotAssetsFailure = createAction('[IotAssets] Load IotAssets Failure', props<{ error: any }>());

// Azioni per il refresh degli IoT Assets
export const refreshIotAssets = createAction(
  '[IotAssets] Refresh IotAssets',
  props<{ assetType: string; uidCustomer: string; uidAssets: string[] }>()
);
export const refreshIotAssetsSuccess = createAction(
  '[IotAssets] Refresh IotAssets Success',
  props<{ iotAssets: IotAsset[] }>()
);
export const refreshIotAssetsFailure = createAction('[IotAssets] Refresh IotAssets Failure', props<{ error: any }>());

// Azioni per gestire lo stato di caricamento e aggiornamento
export const setLoading = createAction('[IotAssets] Set Loading', props<{ isLoading: boolean }>());
export const setRefreshing = createAction('[IotAssets] Set Refreshing', props<{ isRefreshing: boolean }>());
export const updateIotAssetSelected = createAction(
  '[IotAssets] Update IotAsset Selected',
  props<{ vin: string; selected: boolean }>()
);
export const deselectAllIotAssets = createAction(
  '[IotAssets] Deselect All IotAssets'
);

// Azioni per la gestione della configurazione di mapping
export const loadMappingConfig = createAction('[IotAssets] Load Mapping Config');
export const loadMappingConfigSuccess = createAction(
  '[IotAssets] Load Mapping Config Success',
  props<{ mappingConfig: AssetMappingConfig }>()
);
export const loadMappingConfigFailure = createAction(
  '[IotAssets] Load Mapping Config Failure',
  props<{ error: any }>()
);

export const saveMappingConfig = createAction(
  '[IotAssets] Save Mapping Config',
  props<{ mappingConfig: AssetMappingConfig }>()
);
export const saveMappingConfigSuccess = createAction(
  '[IotAssets] Save Mapping Config Success',
  props<{ mappingConfig: AssetMappingConfig }>()
);
export const saveMappingConfigFailure = createAction(
  '[IotAssets] Save Mapping Config Failure',
  props<{ error: any }>()
);

export const updateMappingConfig = createAction(
  '[IotAssets] Update Mapping Config',
  props<{ mappingConfig: AssetMappingConfig }>()
);

// Azione per aggiornare la visibilità di un singolo campo
export const updateFieldVisibility = createAction(
  '[IotAssets] Update Field Visibility',
  props<{ fieldName: string; visible: boolean }>()
);
